export const FILTERS_STORAGE_ROOT_KEY = 'filters';

// Чистит все сохранённые фильтры — единый корневой ключ, данные не протекают между аккаунтами
export function clearFiltersStorage(): void {
  try {
    localStorage.removeItem(FILTERS_STORAGE_ROOT_KEY);
  } catch (error) {
    console.warn('Failed to clear saved filters in localStorage', error);
  }
}
